import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export const NoPage = () => {
	const navigate = useNavigate();

	return (
		<Result
			status="404"
			title="404"
			subTitle="抱歉，您访问的页面不存在"
			extra={[
				<Button type="primary" key="home" onClick={() => navigate('/')}>
					返回首页
				</Button>,
				<Button key="back" onClick={() => navigate(-1)}>
					返回上一页
				</Button>,
			]}
		/>
	);
};

export default NoPage;
